import { PushTopic } from "@seneca/notifications-service-types";

const supportedAnalyticsSources: PushTopic[] = [
  "childCompletesAssignment",
  "childAssignmentSet",
  "parentWeeklyReport"
];

export default function isSupportedPushAnalyticsSource(
  source?: PushTopic | null
) {
  if (!source) return false;

  return supportedAnalyticsSources.some(supported => supported === source);
}
